import {useStore} from "vuex";
import {computed} from "vue";


export default function useReport() {
  const store = useStore()

  const loadChild = (map, links) => {
    const link = links.find(i => i.rel === 'children' && i.action === 'GET')
    if (link) {
      return store.dispatch('report/loadChildren', {map, link: link.href})
    }
  }

  const getCountHouses = links => {
    const link = links.find(i => i.rel === 'num_passports' && i.action === 'GET')
    if (link) {
      return store.dispatch('report/getCountHouses', link.href)
    }
  }

  const createReport = links => {
    const reportFullLink = links.find(i => i.rel === 'report_detail_xls' && i.action === 'GET')
    store.commit('report/setXlsReportLinks', {
      summary: links.find(i => i.rel === 'report_xls' && i.action === 'GET').href,
      full: reportFullLink ? reportFullLink.href : undefined
    })
    const link = links.find(i => i.rel === 'report' && i.action === 'GET')
    if (link) {
      return store.dispatch('report/createReport', link.href)
    }
  }

  const filterReportData = computed({
    get: () => store.state.report.filterReportData,
    set: newVal => store.commit('report/setFilterReportData', newVal)
  })

  const downloadSummaryReport = () => store.dispatch('report/loadSummaryReport')
    .then(downloadReport)

  const downloadFullReport = () => store.dispatch('report/loadFullReport')
    .then(downloadReport)

  const downloadReport = response => {
    const url = window.URL.createObjectURL(response.data)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', response.filename)
    document.body.appendChild(link);
    link.click()
  }

  return {
    housesTree: computed(() => store.state.report.housesTree),
    isCountHousesLoading: computed(() => store.state.report.isCountHousesLoading),
    isReportCreating: computed(() => store.state.report.isReportCreating),
    countHouses: computed(() => store.state.report.countHouses),
    reportData: computed(() => store.state.report.reportData),
    getReportData: computed(() => store.getters["report/getReportData"]),
    getFilteredReportData: computed(() => store.getters["report/getFilteredReportData"]),
    isFullReportLinkExists: computed(() => store.state.report.xlsReportLink.full),
    clearReportState: () => store.commit('report/clearReportState'),
    loadChild,
    getCountHouses,
    createReport,
    filterReportData,
    downloadSummaryReport,
    downloadFullReport
  }
}
